import { type AppActions, HIDE_SESSION_EXPIRED_DIALOG } from './actions';

export interface AppState {
    sessionExpiredAcknowledged: boolean;
}

const initialState: AppState = {
    sessionExpiredAcknowledged: false,
};

const reducer = (state: AppState, action: AppActions): AppState => {
    const appState = state ?? initialState;
    switch (action.type) {
        case HIDE_SESSION_EXPIRED_DIALOG:
            return {
                ...appState,
                sessionExpiredAcknowledged: true,
            };
        default:
            return appState;
    }
};

export default reducer;
